import { filing } from './toolkit';

/** Report of estate not fully distributed (22 NYCRR 207.42), one page. */
export default filing('file-1787161828709-f9038649-badc-4e77-bd7f-17f8489456db.pdf', 'Report of estate not fully distributed', f => {
  const P = (n: number) => `topmostSubform[0].Page1[0].TextField${n}[0]`;

  f.shared(P(1), 'estate.surrogateCourtCounty', "Surrogate's Court, County of");
  f.shared(P(2), 'decedent.fullName', 'Estate of (decedent name), Deceased');
  f.shared(P(3), 'estate.courtFileNumber', 'File No.');
  f.shared(P(4), 'estate.dateOfLetters', 'Date of issuance of first permanent letters');

  f.shared(P(5), 'totals.reportGrossEstate', 'Approximate amount of gross estate ($)',
    { location: 'Sum of asset date-of-death values; blank while any asset lacks a date-of-death value.' });
  f.shared(P(6), 'totals.reportDistributedToBeneficiaries', 'Approximate amount that has been distributed to beneficiaries ($)',
    { location: 'Sum of distribution values of assets distributed to beneficiaries; blank while any lacks a distribution value.' });
  f.shared(P(7), 'totals.reportRemainingInHands', "Approximate amount remaining in fiduciary's hands at present ($)",
    { location: 'Sum of current market values of assets not yet disposed of (leases excluded).' });

  const reason = 'Estate: reason not fully distributed and expected distribution date, wrapped over four lines.';
  f.shared(P(8), 'totals.reportReasonLine1', 'Reason estate not fully distributed (state briefly and date distribution expected): line 1', { location: reason });
  f.shared(P(9), 'totals.reportReasonLine2', 'Reason estate not fully distributed: line 2', { location: reason });
  f.shared(P(10), 'totals.reportReasonLine3', 'Reason estate not fully distributed: line 3', { location: reason });
  f.shared(P(11), 'totals.reportReasonLine4', 'Reason estate not fully distributed: line 4', { location: reason });

  f.signature(P(12), 'Date of this report (completed at signing)');

  f.signature(P(13), 'Fiduciary: signature');
  f.template(P(14), '{{executor.addresses[0].addressLine1}} {{executor.addresses[0].addressLine2}}', 'Fiduciary: address (street)');
  f.template(P(15), '{{executor.addresses[0].city}}, {{executor.addresses[0].state}} {{executor.addresses[0].zipCode}}', 'Fiduciary: address (city, state and ZIP)');
  f.shared(P(16), 'executor.phone', 'Fiduciary: phone');

  f.signature(P(17), 'Attorney for above Fiduciary: signature');
  f.template(P(18), '{{lawyer.addresses[0].addressLine1}} {{lawyer.addresses[0].addressLine2}}', 'Attorney: address (street)');
  f.template(P(19), '{{lawyer.addresses[0].city}}, {{lawyer.addresses[0].state}} {{lawyer.addresses[0].zipCode}}', 'Attorney: address (city, state and ZIP)');
  f.shared(P(20), 'lawyer.phone', 'Attorney: phone');
});
